import React from 'react';

/**
 * Product Detail Skeleton Loader
 * Shows while product data is loading
 */
const ProductSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50 animate-pulse">
      <div className="bg-white p-6 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Image Skeleton */}
            <div className="lg:col-span-1">
              <div className="bg-gray-200 rounded-lg h-96 w-full"></div>
              <div className="flex gap-2 mt-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="bg-gray-200 rounded h-20 w-20"></div>
                ))}
              </div>
            </div>

            {/* Info Skeleton */}
            <div className="lg:col-span-1 space-y-4">
              <div className="bg-gray-200 rounded h-8 w-3/4"></div>
              <div className="bg-gray-200 rounded h-4 w-1/2"></div>
              <div className="bg-gray-200 rounded h-10 w-1/3"></div>
              <div className="space-y-2">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="bg-gray-200 rounded h-4 w-full"></div>
                ))}
              </div>
            </div>

            {/* Purchase Options Skeleton */}
            <div className="lg:col-span-1">
              <div className="border rounded-lg p-4 bg-white space-y-4">
                <div className="bg-gray-200 rounded h-10 w-1/2"></div>
                <div className="bg-gray-200 rounded h-10 w-32"></div>
                <div className="bg-gray-200 rounded-lg h-12 w-full"></div>
                <div className="bg-gray-200 rounded-lg h-12 w-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
